import { prefixerM } from '.'

export const ROUTE_ENTIDADES = prefixerM('entidades')
export const ROUTE_REGISTRAR_ENTIDAD = prefixerM('registrar-entidad')
export const ROUTE_PROVEEDOR = prefixerM('proveedor')
export const ROUTE_REGISTRAR_PROVEEDOR = prefixerM('registrar-proveedor')
